import _Object$keys from 'babel-runtime/core-js/object/keys';
import 'babel-polyfill';
import Vue from 'vue';

import 'normalize.css/normalize.css'; // A modern alternative to CSS resets

import ElementUI from 'element-ui';
Vue.use(ElementUI);
import 'element-ui/lib/theme-chalk/index.css';

import '@/styles/index.scss'; // global css
import '@/styles/adjust.scss'; // adjust css
import App from './App';
import router from './router';
import store from './store';

import cache from '@/utils/cache';
cache.loadingCache();

import '@/permission'; // permission control
import '@/styles/animate.css';

import 'babel-polyfill';

/** 事件传递 */
import VueBus from 'vue-bus';

Vue.use(VueBus);
/** 常用flex组件 */
import { Flexbox, FlexboxItem } from '@/components/flexbox';
Vue.component('flexbox', Flexbox);
Vue.component('flexbox-item', FlexboxItem);

/** 懒加载图片 */
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@/assets/img/send_img.png'),
  loading: require('@/assets/img/loading.gif'),
  attempt: 1
});

import * as filters from './filters'; // global filters
// 注册全局过滤器
_Object$keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});

// 处理时间的过滤器
Vue.use(require('vue-moment'));
import moment from 'moment';
moment.locale('zh_cn');

// 自定义全局点击空白处组件
import clickoutside from './directives';
Vue.directive('clickoutside', clickoutside);
import empty from './directives/empty';
Vue.use(empty);
import photo from './directives/photo';
Vue.use(photo);

// 打印
import Print from '@/utils/print';
Vue.use(Print);

import axios from 'axios';
Vue.prototype.$reqs = axios; // 配置axios的访问方式

import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';

import echarts from "echarts";
Vue.prototype.$echarts = echarts;

Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

// 表情
// import {
//   emoji
// } from './utils/emoji'
// Vue.prototype.emoji = emoji

Vue.config.productionTip = false;

window.app = new Vue({
  el: '#app',
  router: router,
  store: store,
  data: {
    eventHub: new Vue()
  },
  render: function render(h) {
    return h(App);
  }
});

Vue.filter('NumFormat', function (value) {
  if (!value) return '0.00';

  /*原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1，感谢Nils指正*/
  /*后来改成了 Number(value)|0,但是输入超过十一位就为负数了，具体见评论 */
  var intPart = Number(value) - Number(value) % 1; //获取整数部分（这里是windy93的方法）
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

  var floatPart = ".00"; //预定义小数部分
  var value2Array = value.toString().split(".");

  //=2表示数据有小数位
  if (value2Array.length == 2) {
    floatPart = value2Array[1].toString(); //拿到小数部分

    if (floatPart.length == 1) {
      //补0,实际上用不着
      return intPartFormat + "." + floatPart + '0';
    } else {
      return intPartFormat + "." + floatPart;
    }
  } else {
    return intPartFormat + floatPart;
  }
});